import React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { FieldGroup } from "../Groups/FieldGroup";
import { RadioField } from "../Fields/RadioField";
import { Condition } from "../Conditionals/Condition";
import { TextareaField } from "../Fields/TextareaField";
import { Images } from "./Options/ImagesForm";
import { BoothLayout } from "./Options/BoothLayoutForm";
import { RollUp } from "./Options/RollUpForm";
import { Advertisement } from "./Options/AdvertisementForm";
import { ContentLanguageForm } from "../Parts/ContentLanguageForm";
import { TranslationForm } from "../Parts/TranslationForm";
import { SpecialForm } from "../Parts/SpecialForm";
import { Brochure } from "./Options/BrochureForm";
import { pickOne, requiredField, requiredUpload } from "../Validation";
import { FileField } from "../Fields/FileField";
import {generalHint} from "../TicketingFormConstants"

export const AdvertisingForm = () => {
    const docTypes = ["Images", "Brochure", "Advertisement", "Roll up", "BoothLayout", "Other"];
    return <Row>
        {/* PRODUCT PROMOTIONAL MARKETING MATERIAL FORM HEADER */ }
        <Col md={ 12 }>
            <h1>Product promotional marketing material</h1>
            <p>To best serve you please answer the following questions</p>
        </Col>

        {/* PRODUCT PROMOTIONAL MARKETING MATERIAL FORM BODY*/ }
        <Col md={ 12 }>

            <FieldGroup
                groupName="Product Promotional Marketing Type Option"
                groupId="advertising"
                groupLabel="How can we help you?"
                groupHint="To proceed, you need to make a selection."
                validator={ pickOne }
            >
                {/* IMAGES (opens images form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Images"
                    fieldValue="Images"
                />

                {/* BROCHURE (opens brochure form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Brochure"
                    fieldValue="Brochure"
                />

                {/* ADVERTISEMENT (opens advertisement form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Advertisement"
                    fieldValue="Advertisement"
                />

                {/* ROLL UP (opens roll up form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Roll up"
                    fieldValue="Roll up"
                />

                {/* BOOTH LAYOUT (opens booth layout form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Booth layout"
                    fieldValue="Booth layout"
                />

                {/* OTHER (submit closes the form) */ }
                <RadioField
                    fieldId="Product Promotional Marketing Type Option"
                    fieldLabel="Other"
                    fieldValue="Other"
                />
            </FieldGroup>
            <Condition when="Product Promotional Marketing Type Option" is="Other">
                <TextareaField
                    fieldId="Product Promotional Marketing Type"
                    fieldLabel="Description"
                    fieldRequired={ true }
                    validator={ requiredField }
                />
            </Condition>

            {/* PRODUCT PROMOTIONAL MARKETING MATERIAL TYPE IMAGES */ }
            <Condition when="Product Promotional Marketing Type Option" is="Images">
                <Images/>
                <Condition when="Image Usage" is="Booth layout">
                    <BoothLayout/>
                    <Condition when="Booth layout" is="Roll up">
                        <RollUp/>
                    </Condition>
                </Condition>
                <Condition when="Image Usage" is="Roll up">
                    <RollUp/>
                </Condition>
                <Condition when="Image Usage" is="Advertisement">
                    <Advertisement/>
                </Condition>
                <Condition when="Image Usage" is="Other">
                    {/* TODO: Check if this ROW is necessary */ }
                    <Row>
                        <ContentLanguageForm
                            elementType="image"
                        />
                        <Condition when="Content Language Option" is="Translation">
                            <TranslationForm
                                elementType="image"
                            />
                        </Condition>
                        <Condition when="Content Language Option" is="Special">
                            <SpecialForm/>
                        </Condition>
                    </Row>
                </Condition>
            </Condition>

            {/* PRODUCT PROMOTIONAL MARKETING MATERIAL TYPE BROCHURE */ }
            <Condition when="Product Promotional Marketing Type Option" is="Brochure">
                <Brochure/>
            </Condition>

            {/* PRODUCT PROMOTIONAL MARKETING MATERIAL TYPE ADVERTISEMENT */ }
            <Condition when="Product Promotional Marketing Type Option" is="Advertisement">
                <Advertisement/>
            </Condition>

            {/* PRODUCT PROMOTIONAL MARKETING MATERIAL TYPE BOOTH LAYOUT*/ }
            <Condition when="Product Promotional Marketing Type Option" is="Booth layout">
                <BoothLayout/>
                <Condition when="Booth layout" is="Roll up">
                    <RollUp/>
                </Condition>
            </Condition>

            {/* PRODUCT PROMOTIONAL MARKETING MATERIAL TYPE ROLL UP*/ }
            <Condition when="Product Promotional Marketing Type Option" is="Roll up">
                <RollUp/>
            </Condition>
            {/* PROJECT ATTACHMENTS */ }
            <Col md={ 12 }>
                    { docTypes.map((docType, i) => (
                        <Condition when="Product Promotional Marketing Type Option" is={ docType } key={i}>
                            <FormGroup id="projectAttachment_box">
                                <div>
                                    <FileField
                                        fileFieldId="projectAttachment_file"
                                        fileFieldName="projectAttachment"
                                        hint={ generalHint}
                                        fileFieldLabel="File Upload"
                                        fileFieldMultiple={ true }
                                        validator={ docType!== "Other" ? requiredUpload :  console.log(docType) }
                                    />
                                </div>
                            </FormGroup>
                        </Condition>
                    ))}
            </Col>
        </Col>
    </Row>;
}
